module.exports = __webpack_public_path__ + "fonts/subset-MullerBlack.168c476e.woff";